/** @format */

import { EmployerBusinessState } from './type';

const InitialEmployerBusinessState: EmployerBusinessState = {
    employer: {},
};

export default InitialEmployerBusinessState;